import { type MaybeRefOrGetter } from "vue";

import { SiteQueryKeys } from "@/data/api/site-query-keys";
import { type SiteSectionId, type V4HSiteId } from "@/data/common/ids";

const query = {
  api: "site-section",
  type: "query",
} as const;

export const SiteSectionQueryKeys = {
  isDeletable: (siteId: MaybeRefOrGetter<V4HSiteId>, sectionId: MaybeRefOrGetter<SiteSectionId>) =>
    [...SiteQueryKeys.sections(siteId), query, { action: "find-section-is-deletable", sectionId }] as const,
  findAppliancesV2: (siteId: MaybeRefOrGetter<V4HSiteId>, sectionId: MaybeRefOrGetter<SiteSectionId>) =>
    [...SiteQueryKeys.sections(siteId), query, { action: "find-section-appliances-v2", sectionId }] as const,
  findCategories: (siteId: MaybeRefOrGetter<V4HSiteId>) =>
    [...SiteQueryKeys.sections(siteId), query, { action: "find-section-categories" }] as const,
};
